import { z } from 'zod'
import { del, get, post } from '../axios'
import { client, InviteClientInput } from './client'

export function fetchClients(companyId: string) {
    return get(client.array(), `/companies/${companyId}/clients`)
}

export function inviteClients(companyId: string, input: InviteClientInput) {
    return post(z.unknown(), `/companies/${companyId}/clients/invite`, input)
}

export function deleteClient(companyId: string, userId: string) {
    return del(z.unknown(), `/companies/${companyId}/clients/${userId}`)
}

export function assignClientCampaign(companyId: string, userId: string, campaignId: string) {
    return post(z.unknown(), `/companies/${companyId}/clients/${userId}/campaigns/${campaignId}`, {})
}

export function unassignClientCampaign(companyId: string, userId: string, campaignId: string) {
    return del(z.unknown(), `/companies/${companyId}/clients/${userId}/campaigns/${campaignId}`)
}
